import { Injectable } from '@angular/core';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import { Observable } from 'rxjs/Observable';
import { UtilitiesService } from '../services/utilities.service';
import { DocumentoResultado } from '../model/documento-resultado';
import { Resultado } from 'app/model/resultado';

@Injectable()
export class SubirDocumentosService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }

  public insert(arr: any) {

    let json = { "Metodo": "SubirDocumentos", "Datos": arr };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).timeout(60000).map(res => res.json());

  }
  public insertNuevo(arr: any): Observable<Resultado> {
    // let json = { "Metodo": "SubirDocumentos", "Datos": arr };
    // let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    // let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    // return this._http.post(this._utilities.getURL("post"),
    //   params, { headers: headers }).timeout(60000).map(res => res.json());

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let url = this._utilities.getURLIIS("DocumentoSalida/documentoCrudo/");

    let params = JSON.stringify(arr);

    return this._http.post(url, arr, { headers: headers }).map(res => res.json());

  }

  public verificar(arr: any) {
    let json = { "Metodo": "VerificarArticulo", "Datos": arr };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).timeout(60000).map(res => res.json());
  }

  public confirmar(arr: any) {
    let json = { "Metodo": "ConfirmarDocumento", "Datos": arr };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).timeout(60000).map(res => res.json());
  }

  public RevertirSubida(arr: any) {
    let json = { "Metodo": "RevertirDocumento", "Datos": arr };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).timeout(60000).map(res => res.json());
  }


  obteberResultados(arr: any): Observable<DocumentoResultado[]> {

    let json = { "Metodo": "getSubirArchivoResultados", "Datos": arr };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }


}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/subir-documentos.service.ts